import { useEffect, useRef, useState } from "react";
import { EXPEDITION_STORY_PANELS } from "@zend/content";
import { panelUrl } from "../assets/manifest.js";
import { pick, useT } from "../i18n/index.js";
import { Button } from "../ui/Button.js";
import type { ExpeditionStageView } from "../units/types.js";
import "./story.css";

export function StoryPanel({ story, onEnlarge }: { story: NonNullable<ExpeditionStageView["story"]>; onEnlarge?: () => void }) {
  const t = useT();
  const art = EXPEDITION_STORY_PANELS.find(panel => panel.id === story.panelId);
  const [attempt, setAttempt] = useState(0);
  const [status, setStatus] = useState<"loading" | "ready" | "error">("loading");
  const decodeGeneration = useRef(0);
  useEffect(() => () => { decodeGeneration.current++; }, []);
  const picture = <img key={attempt} src={panelUrl(story.panelId, "1x")} srcSet={`${panelUrl(story.panelId, "1x")} 768w, ${panelUrl(story.panelId)} 1536w`} sizes="(min-width: 900px) 850px, 94vw"
    width={1536} height={864} alt={art ? pick(art.alt) : pick(story.title)} decoding="async" loading="lazy" draggable={false}
    onLoad={event => {
      const img = event.currentTarget, source = img.currentSrc, generation = ++decodeGeneration.current;
      setStatus("loading");
      const current = () => img.isConnected && generation === decodeGeneration.current && img.currentSrc === source;
      void img.decode().then(() => { if (current()) setStatus("ready"); }, () => { if (current()) setStatus("error"); });
    }}
    onError={() => { decodeGeneration.current++; setStatus("error"); }} />;
  return <figure className="story-panel" data-panel-id={story.panelId} data-status={status}>
    <div className="story-picture" aria-busy={status === "loading"}>
      {status !== "error" ? onEnlarge ? <button type="button" className="story-enlarge" onClick={onEnlarge} aria-label={t("story.enlarge")}>{picture}</button> : picture : null}
      {status !== "ready" ? <div className="story-image-status" role="status"><p>{t(status === "error" ? "story.unavailable" : "common.loading")}</p>{status === "error" ? <Button onClick={() => { decodeGeneration.current++; setStatus("loading"); setAttempt(value => value + 1); }}>{t("story.retry")}</Button> : null}</div> : null}
    </div>
    <figcaption><p>{pick(story.lines)}</p></figcaption>
  </figure>;
}
